import { mapGetters } from 'vuex';
import keyboardNumericInputSushi from '@/components/keyboard-numeric-input-sushi/keyboard-numeric-input-sushi.vue';

export default {
  components: {
    keyboardNumericInputSushi,
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price',
    },
    value: {
      type: Number,
      default: 50,
    },
    kind: {
      type: String,
      default: 'modal',
    },
    selected: Boolean,
    tabindex: Number,
  },
  data() {
    return {
      cents: this.value !== null ? parseInt(this.value, 10) : 0,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    minimumCentValue() {
      return 1;
    },
    classModifier() {
      return {
        'purchase-offer-value-sushi': true,
        [`purchase-offer-value-sushi--${this.kind}`]: this.kind,
        'purchase-offer-value-sushi--selected': this.selected,
      };
    },
  },
  watch: {
    cents: 'updateOffer',
    value(value) {
      this.cents = value !== null ? parseInt(value, 10) : 0;
    },
  },
  methods: {
    add() {
      if (isNaN(this.cents) || this.cents === null) this.cents = this.minimumCentValue;
      this.cents += 1;
    },
    subtract() {
      if (isNaN(this.cents) || this.cents === null) this.cents = this.minimumCentValue;
      if (this.cents === this.minimumCentValue) return;
      this.cents -= 1;
    },
    updateOffer() {
      this.cents = parseInt(this.cents, 10);
      if (isNaN(this.cents) || this.cents < 1) this.cents = null;
      else if (this.cents > 99) this.cents = 99;

      if (this.cents !== null) {
        this.$emit('input', Number(this.cents));
      } else {
        this.$emit('input', this.cents);
      }
    },
    click() {
      this.$emit('click');
    },
    onBoxClick() {
      if (this.isLayoutDesktop) {
        this.$refs.input.focus();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-offer-value-sushi/purchase-offer-value-sushi.js